import { render, staticRenderFns } from "./NaverPayGuide.vue?vue&type=template&id=28449bf4&"
import script from "./NaverPayGuide.vue?vue&type=script&lang=ts&"
export * from "./NaverPayGuide.vue?vue&type=script&lang=ts&"
import style0 from "./NaverPayGuide.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports